import React from 'react'
import { MenuItem, Dropdown, Button } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

const handleClick = (newValue, onChange) => () => {
  onChange({ target: { value: newValue } })
}

const ForceButton = ({ href, children, ...props }) => (
  <Button bsStyle='link' {...props}>{children}</Button>
);

function SelectInput({ choices, onChange, value, className }) {
  const selectedChoice = choices.find(choice => choice.value === value)
  return (
    <div className="button-select-input">
      <Dropdown>
        <Dropdown.Toggle bsStyle={'Default'} noCaret className={className}>
          {selectedChoice ? selectedChoice.label : ''}
          <FontAwesome name="caret-down" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {choices.filter(choice => choice.value !== value).map((choice, index) => (
            <MenuItem key={choice.value} eventKey={index} onClick={handleClick(choice.value, onChange)} componentClass={ForceButton} href={false}>{choice.label || choice.value}</MenuItem>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}

export default SelectInput



// WEBPACK FOOTER //
// ./src/components/Select/SelectInput.js